import type { PersistentMessagesContextType } from './types';

import { createContext } from 'react';

export const PersistentMessagesContext = createContext(
  {} as PersistentMessagesContextType,
);
